/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-pinterest': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 00-3.188 16.875 8.275 8.275 0 010-2.5l1.032-4.375A3.156 3.156 0 017.606 10c0-1.213.707-2.125 1.582-2.125a1.1 1.1 0 011.106 1.25c0 .75-.475 1.875-.725 2.912a1.25 1.25 0 001.3 1.582c1.55 0 2.75-1.644 2.75-4.006A3.456 3.456 0 009.963 6.05a3.787 3.787 0 00-3.95 3.8 3.387 3.387 0 00.625 1.994.275.275 0 01.062.25c-.069.275-.219.875-.244.994-.025.118-.131.193-.294.118-1.093-.512-1.774-2.106-1.774-3.393 0-2.757 2.006-5.294 5.78-5.294 3.032 0 5.395 2.162 5.395 5.056 0 3.013-1.876 5.438-4.544 5.438a2.35 2.35 0 01-2.007-1l-.543 2.08a9.719 9.719 0 01-1.088 2.294c.85.252 1.733.374 2.619.363a8.75 8.75 0 100-17.5"/>'
  }
})
